// Çatı Mock Data
// Çatı malzemeleri, kiremit ve izolasyon takibi

export const catiMalzemeler = [
    {
        id: 'ct-001',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-14',
        tedarikci: 'Marsilya Kiremit',
        tedarikciFirmaId: 'f-110',
        kategori: 'kiremit',
        urunAdi: 'Marsilya Kiremit',
        aciklama: 'Kırmızı Pişmiş Toprak',
        renk: 'Kırmızı',
        miktar: 5000,
        birim: 'adet',
        metrekareKarsiligi: 400,
        birimFiyat: 12,
        toplamFiyat: 60000,
        durum: 'teslim',
        stokMiktar: 1500,
        kullanilanMiktar: 3500,
        uygulamaYeri: 'A Blok Çatı',
        insaatId: 'c-001',
        not: 'Ana çatı kiremidi',
        createdAt: '2026-01-12T08:00:00Z',
        updatedAt: '2026-01-17T15:00:00Z',
    },
    {
        id: 'ct-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Onduline',
        tedarikciFirmaId: 'f-111',
        kategori: 'su-izolasyon',
        urunAdi: 'Çatı Membranı',
        aciklama: 'Bitümlü Su Yalıtım Örtüsü',
        renk: 'Siyah',
        miktar: 500,
        birim: 'm²',
        metrekareKarsiligi: null,
        birimFiyat: 85,
        toplamFiyat: 42500,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 500,
        uygulamaYeri: 'A Blok Çatı',
        insaatId: 'c-001',
        not: 'Su yalıtımı tamamlandı',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-15T16:00:00Z',
    },
    {
        id: 'ct-003',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Kereste A.Ş.',
        tedarikciFirmaId: 'f-112',
        kategori: 'ahsap',
        urunAdi: 'Çatı Makas Kerestesi',
        aciklama: '8x16 Çam Kereste',
        renk: 'Doğal',
        miktar: 150,
        birim: 'm³',
        metrekareKarsiligi: null,
        birimFiyat: 8500,
        toplamFiyat: 1275000,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 150,
        uygulamaYeri: 'A Blok Çatı',
        insaatId: 'c-001',
        not: 'Makas ve mertekler tamamlandı',
        createdAt: '2026-01-08T07:00:00Z',
        updatedAt: '2026-01-12T17:00:00Z',
    },
    {
        id: 'ct-004',
        siparisTarihi: '2026-01-14',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Marsilya Kiremit',
        tedarikciFirmaId: 'f-110',
        kategori: 'aksesucar',
        urunAdi: 'Mahya Kiremidi',
        aciklama: 'Kırmızı Mahya',
        renk: 'Kırmızı',
        miktar: 200,
        birim: 'adet',
        metrekareKarsiligi: null,
        birimFiyat: 25,
        toplamFiyat: 5000,
        durum: 'teslim',
        stokMiktar: 50,
        kullanilanMiktar: 150,
        uygulamaYeri: 'A Blok Çatı',
        insaatId: 'c-001',
        not: 'Mahya uygulaması devam ediyor',
        createdAt: '2026-01-14T10:00:00Z',
        updatedAt: '2026-01-17T14:00:00Z',
    },
];

// Çatı kategorileri
export const catiKategorileri = [
    { key: 'kiremit', label: 'Kiremit', icon: '🏠' },
    { key: 'su-izolasyon', label: 'Su İzolasyonu', icon: '💧' },
    { key: 'ahsap', label: 'Ahşap Konstrüksiyon', icon: '🪵' },
    { key: 'aksesucar', label: 'Aksesuar', icon: '🔧' },
    { key: 'oluk', label: 'Oluk Sistemi', icon: '🌧️' },
    { key: 'kaplamali', label: 'Kaplamalı Çatı', icon: '🛠️' },
];

// İmalat durumları
export const imalatDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'info' },
    { key: 'devam', label: 'Devam Ediyor', color: 'warning' },
    { key: 'tamamlandi', label: 'Tamamlandı', color: 'success' },
];

// İstatistikler
export const getCatiStats = (insaatId) => {
    const filtered = insaatId
        ? catiMalzemeler.filter(s => s.insaatId === insaatId)
        : catiMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const tamamlanan = filtered.filter(s => s.imalatDurumu === 'tamamlandi').length;
    const devamEden = filtered.filter(s => s.imalatDurumu === 'devam').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const toplamMetrekare = filtered
        .filter(s => s.metrekareKarsiligi)
        .reduce((acc, s) => acc + s.metrekareKarsiligi, 0);

    return { toplamKalem, teslimEdilen, tamamlanan, devamEden, toplamMaliyet, toplamMetrekare };
};

// Helper: insaata göre filtrele
export const getCatiByInsaat = (insaatId) => {
    if (!insaatId) return catiMalzemeler;
    return catiMalzemeler.filter(s => s.insaatId === insaatId);
};
